import React, { useState, useEffect, FC } from 'react';
import { View, Modal } from 'react-native';
import { trackClick, trackClickEvent } from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import BillingAddress from '@RN_UI_Lib/BillingAddressRN';
import { showShortToast } from '@mmt/legacy-commons/Common/Components/Toast';
import StateSelection from '../StateSelectionModal/StateSelectionModal';
import { BillingAddressProps } from '../../Helpers/interfaces';
import { pageName } from '../../Helpers/utils';
import {
    ERROR_MSG_COLOR,
    SELECT_STATE,
    PREFILL_LOCUS_API,
    GSTIN_OMNITURE,
    TRACKING_STATE_TYPE,
    CONSENT_MSG_DEFAULT_COLOR,
} from '../../Helpers/constants';

const GSTIN = (props: BillingAddressProps) => {
    const {
        lob,
        state,
        userConsent,
        highlightUserConsentError,
        initialise,
        stateUpdate,
        userConsentUpdate,
        highlightUserConsentErrorUpdate,
        sourceState
    } = props;

    const [showToolTip, setShowToolTip] = useState(false);
    const [showStateSelection, setShowStateSelection] = useState(false);

    const lobPageName: string = pageName(lob);

    useEffect(() => {
        if (!state) {
            initialise(lob);
            (async function () {
                await fetchPrefillData();
            })();
        }

        return () => {
            highlightUserConsentErrorUpdate(false);
        }
    }, []);

    async function fetchPrefillData() {
        var myHeaders = new Headers();
        myHeaders.append("authorization", "h4nhc9jcgpAGIjp");
        myHeaders.append("api-key", "GROUND-RAILS-718152114418191219");
        myHeaders.append("Content-Type", "text/plain");

        var raw = "{\nlocationHierarchy(lat:,lng:) {\ncountry {\nid\nname\ncentre\n}\nstate {\nid\nname\ncentre\n}\ncity {\nid\nname\ncentre\npostal_code\n}\narea {\nid\nname\nprimary_area\ncentre\npostal_code\n}\n}\n}\n";

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
        };

        fetch(PREFILL_LOCUS_API, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    transformPrefillData(result);
                } else {
                    trackClick(lobPageName, GSTIN_OMNITURE.BAC_blank_render, {});
                }
            })
            .catch(err => {
                console.log(err);
                trackClick(lobPageName, GSTIN_OMNITURE.BAC_blank_render, {});
            });
    }

    function transformPrefillData(res: any) {
        const {
            data: {
                locationHierarchy: {
                    state: locationState,
                },
            },
        } = res;

        const location_state = locationState && locationState[0]?.name;

        stateUpdate(location_state);
        trackClick(lobPageName, GSTIN_OMNITURE.BAC_filled_render, {});
        trackStateMatch(location_state, TRACKING_STATE_TYPE.prefilled);
    }

    const trackStateMatch = (state: string, stateType: string) => {
        try {
            if (sourceState) {
                const statesMatch = sourceState?.toLowerCase()?.includes(state?.toLowerCase());

                if (stateType === TRACKING_STATE_TYPE.prefilled) {
                    if (statesMatch) {
                        trackClickEvent(lobPageName, GSTIN_OMNITURE.Re_GSTWidget_State_Match);
                    } else {
                        trackClickEvent(lobPageName, GSTIN_OMNITURE.Re_GSTWidget_State_Mismatch);
                    }
                } else if (stateType === TRACKING_STATE_TYPE.userSelected) {
                    if (statesMatch) {
                        trackClickEvent(lobPageName, GSTIN_OMNITURE.Re_GSTWidget_State_edit_match);
                    } else {
                        trackClickEvent(lobPageName, GSTIN_OMNITURE.Re_GSTWidget_State_edit_mismatch);
                    }
                }
            }
        } catch (err) {
            // empty catch block
        }
    };

    const onDismissModal = () => {
        setShowStateSelection(false);
    };

    const onSelect = (value: string) => {
        stateUpdate(value);
        trackStateMatch(value, TRACKING_STATE_TYPE.userSelected);
        onDismissModal();
    };

    const onSaveCheckboxChecked = async (val: boolean) => {
        if (!state || state === '') {
            userConsentUpdate(false);
            highlightUserConsentErrorUpdate(true);
            showShortToast(SELECT_STATE);
            return;
        }
        if (!userConsent) {
            trackClickEvent(lobPageName, GSTIN_OMNITURE.BAC_confirm_click);
        }
        userConsentUpdate(!userConsent);
        if (userConsent) {
            highlightUserConsentErrorUpdate(true);
        } else {
            highlightUserConsentErrorUpdate(false);
        }
    };

    const stateChangePressed = () => {
        setShowStateSelection(true);
        trackClickEvent(lobPageName, GSTIN_OMNITURE.BAC_state_edit);
    };

    const infoIconPressed = () => {
        setShowToolTip(!showToolTip);
        trackClickEvent(lobPageName, GSTIN_OMNITURE.BAC_info_click);
    };

    return (
        <>
            {
                showStateSelection ? (
                    <Modal
                        animationType="slide"
                        onRequestClose={onDismissModal}
                        presentationStyle={'formSheet'}
                    >
                        <StateSelection
                            closeHandler={onDismissModal}
                            selectHandler={onSelect}
                        />
                    </Modal>
                ) :
                    <View>
                        <BillingAddress
                            theme={'MMT'}
                            isSavedErr={!userConsent ? true : false}
                            stateValue={state}
                            showToolTip={showToolTip}
                            onSelectPress={stateChangePressed}
                            onSavedChange={onSaveCheckboxChecked}
                            savedChecked={userConsent}
                            onInfoPress={infoIconPressed}
                            chkBoxErrTextStyle={{ color: !userConsent && highlightUserConsentError ? ERROR_MSG_COLOR : CONSENT_MSG_DEFAULT_COLOR }}
                            cstTipWrpStyle={{ left: 32.5 }}
                        />
                    </View>
            }
        </>
    );
};

export default GSTIN;
